import { render, staticRenderFns } from "./CopyIcon.vue?vue&type=template&id=79bc478b&"
import script from "./CopyIcon.vue?vue&type=script&lang=js&"
export * from "./CopyIcon.vue?vue&type=script&lang=js&"
import style0 from "./CopyIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports